import React from 'react'
import injectStyles from 'react-jss'

import DatePicker from 'rc-calendar/lib/Picker'
import Calendar from 'rc-calendar'
import moment from 'moment'
import { styles } from './styles'
import ArrowIcon from 'Assets/Images/icons/arrow'
import ScheduleIcon from 'Assets/Images/icons/schedule'

const calendar = <Calendar />

const DateRangeSelector = ({
  title,
  value,
  onChange,
  disabled = false,
  classes,
  icon = 'arrow',
}) => (
  <div className={classes.container}>
    <span className={classes.datePickerHeaderTitle}>{title}</span>
    <div className={classes.inputWrapper}>
      <DatePicker
        animation="slide-up"
        value={value ? moment(value) : value}
        calendar={calendar}
        onChange={onChange}
        disabled={disabled}
      >
        {({ value }) => {
          return (
            <input
              className={classes.input}
              value={
                value
                  ? moment(value).format('DD/MM/YYYY')
                  : icon === 'schedule'
                  ? 'Date'
                  : 'ALL'
              }
              cypress_id={
                title
                  ? title.split(' ').join('-') + '-campaigns-page-date-filter'
                  : null
              }
            />
          )
        }}
      </DatePicker>
      {icon === 'arrow' && (
        <ArrowIcon className={`${classes.icon} ${classes.rotatedIcon}`} />
      )}
      {icon === 'schedule' && <ScheduleIcon className={classes.icon} />}
    </div>
  </div>
)

export default injectStyles(styles)(DateRangeSelector)
